
import { Space, Input, DatePicker, Button } from '@pankod/refine-antd';
import { SearchOutlined } from '@ant-design/icons';
import { useTranslate } from '@pankod/refine-core';
import type { ColumnType } from 'antd/es/table';

export const getColumnSearchProps = (
  dataIndex: string,
  type: string,
): ColumnType<any> => {
  const t = useTranslate();

  // Mapping des valeurs traduites vers les valeurs brutes pour validation_status
  const statusTranslationMap: { [key: string]: string } = {
    [t('status.pending', { ns: 'ownerships' }).toLowerCase()]: 'pending',
    [t('status.accepted', { ns: 'ownerships' }).toLowerCase()]: 'accepted',
    [t('status.rejected', { ns: 'ownerships' }).toLowerCase()]: 'rejected',
  };

  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
      let input = (
        <Input
          placeholder={t('search.placeholder', { ns: 'common', defaultValue: `Rechercher ${dataIndex}` })}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm({ closeDropdown: false })}
          style={{ marginBottom: 8, display: 'block' }}
        />
      );

      if (type === 'date') {
        input = (
          <div style={{ padding: 8 }}>
            <DatePicker
              placeholder={t('search.dateFrom', { ns: 'common', defaultValue: 'Date de début' })}
              style={{ marginRight: '10px' }}
              format="YYYY-MM-DD"
              onChange={(e) => {
                const newvalue = [];
                newvalue.push(e?.toDate().toISOString().split('T')[0] || '');
                if (selectedKeys[1]) newvalue.push(selectedKeys[1]);
                setSelectedKeys(newvalue);
              }}
            />
            <DatePicker
              placeholder={t('search.dateTo', { ns: 'common', defaultValue: 'Date de fin' })}
              format="YYYY-MM-DD"
              onChange={(e) => {
                const newvalue = [];
                newvalue.push(selectedKeys[0]);
                if (e) newvalue.push(e.toDate().toISOString().split('T')[0]);
                setSelectedKeys(newvalue);
              }}
            />
          </div>
        );
      }

      return (
        <div style={{ padding: 8 }}>
          {input}
          <Space>
            <Button
              type="primary"
              onClick={() => confirm({ closeDropdown: false })}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              {t('buttons.search', { ns: 'common', defaultValue: 'Rechercher' })}
            </Button>
            <Button
              onClick={() => {
                clearFilters && clearFilters();
                confirm();
              }}
              size="small"
              style={{ width: 90 }}
            >
              {t('buttons.reset', { ns: 'common', defaultValue: 'Réinitialiser' })}
            </Button>
          </Space>
        </div>
      );
    },
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value: string | number | boolean, record: any) => {
      const recordValue = record[dataIndex]?.toString().toLowerCase();
      let searchValue = value.toString().toLowerCase();

      // Pour la colonne validation_status, convertir la valeur de recherche traduite en valeur brute
      if (dataIndex === 'validation_status') {
        searchValue = statusTranslationMap[searchValue] || searchValue;
      }

      return recordValue?.includes(searchValue);
    },
    render: (value: any) => {
      // Afficher la valeur traduite pour validation_status
      if (dataIndex === 'validation_status' && value) {
        return t(`status.${value}`, { ns: 'ownerships' });
      }
      return value;
    },
  };
};
